import React, {useState, useEffect} from "react";
import data from "./resources/data.json";
import Asset from "./components/Asset";
import FilterTexts from "./components/FilterTexts";

function App() {
    const [assets, setAssets] = useState(data.assets);

    const [filterTexts, setFilterTexts] = useState([]);

    const assetFilter = (asset) => {
        // if no filter tags
        if (filterTexts.length === 0) {
            return true;
        }

        // if asset has tag
        const assetTags = asset.tags.map((tag) => tag.id);
        // match asset tags and filter text
        const matchTags = filterTexts.filter((filterTag) =>
            assetTags.includes(filterTag),
        );

        return matchTags.length === filterTexts.length;
    };

    const handleRemoveAssetTag = (clickedAsset, clickedTag) => {
        if (!clickedAsset || !clickedTag) {
            return;
        }
        // remove tad from asset
        const resTags = clickedAsset.tags.filter(tag => tag.id !== clickedTag.id);
        const changedAsset = {...clickedAsset, tags: resTags};

        const resAsset = assets.filter(asset => asset !== clickedAsset);
        setAssets([changedAsset, ...resAsset]);
    };

    const handleAppendAssetTag = (clickedAsset, newTag) => {
        if (!clickedAsset || !newTag) {
            return;
        }

        // check if asset has this one
        const matchTags = clickedAsset.tags.filter(tag => tag.id === newTag.id);
        if (matchTags.length > 0) {
            alert(`${newTag.text} Tag is already tagged`);
            return;
        }

        // append tad to asset
        const resAsset = assets.filter(asset => asset !== clickedAsset);
        const newTags = [newTag, ...clickedAsset.tags];
        const changedAsset = {...clickedAsset, tags: newTags};
        setAssets([changedAsset, ...resAsset]);
    };

    return (
        <div className="container mx-auto">
            <h1 className="text-lg font-bold text-center">React Tagging Assets</h1>

            <FilterTexts
                filterTexts={filterTexts}
                setFilterTexts={setFilterTexts}/>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3">
                {assets.map(
                    (asset) =>
                        assetFilter(asset)
                        && <Asset key={asset.title}
                                  asset={asset}
                                  handleRemoveAssetTag={handleRemoveAssetTag}
                                  handleAppendAssetTag={handleAppendAssetTag}/>,
                )}
            </div>
        </div>
    );
}

export default App;
